import script from "./QuickpaySettingsSetupProviderInfoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./QuickpaySettingsSetupProviderInfoCard.vue?vue&type=script&setup=true&lang=js"

import "./QuickpaySettingsSetupProviderInfoCard.vue?vue&type=style&index=0&id=58d36734&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58d36734"]])

export default __exports__